import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  Log,
  PLURAL_KEY,
  RydeProcessTitle,
  RydeUiUnit,
  TAddressedFieldsValueOnCompleted,
  useProcesses,
} from "@ryde/shared";

export const useWatchBulkNotificationMarkAsRead = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const { t } = useTranslation();
  const { stopProcessPolling } = useProcesses();
  const bulkUpdateNotificationAsReadProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkUpdateNotificationAsRead,
    entity,
  );
  const bulkUpdateNotificationAsReadProcess = useRecoilValue(
    activeProcessSF(bulkUpdateNotificationAsReadProcessKey),
  );

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      Log.infoAndToast(
        t("general.ENTITY_SUCCESSFULLY_UPDATED", {
          entity: t(`${entity}.${PLURAL_KEY}`),
        }),
      );
      addressedFieldsValueOnCompleted(process);
    },
    [entity, addressedFieldsValueOnCompleted, t],
  );

  useEffect(() => {
    handleProcess({
      onComplete,
      entity,
      processTitle: RydeProcessTitle.BulkUpdateNotificationAsRead,
      process: bulkUpdateNotificationAsReadProcess,
      stopProcessPolling,
      translationFunction: t,
    });
  }, [
    bulkUpdateNotificationAsReadProcess,
    entity,
    onComplete,
    stopProcessPolling,
    t,
  ]);
};
